import clientAxios from "../config/axios";
import { types } from "../types";
import { errorAlert, successAlert } from "./alerts";
import { setLoading, removeLoading, closeModal } from "./ui";

export const getColleges = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.get("/api/v1/colleges");
      // console.log(result);
      dispatch({
        type: types.getCollege,
        payload: result.data.colleges,
      });
      
    } catch (error) {
      console.log(error);
    }
    dispatch(removeLoading());
  };
};

export const createCollege = (college) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      const result = await clientAxios.post("/api/v1/colleges", college);

      dispatch({
        type: types.createCollege,
        payload: result.data,
      });

      dispatch(
        successAlert(`${result.statusText} College Created`, result.status)
      );
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const updateCollege = (college) => {
  //El type tiene el mismo nombre Ojo
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      const result = await clientAxios.put(
        `/api/v1/colleges/${college._id}`,
        college
      );

      // console.log(result)

      dispatch({
        type: types.updateCollege,
        payload: result.data,
      });

      dispatch(
        successAlert(` ${result.statusText} College Updated`, result.status)
      );
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const deleteCollege = (collegeId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      await clientAxios.delete(`/api/v1/colleges/${collegeId}`);
      dispatch({
        type: types.deleteCollege,
        payload: collegeId,
      });
      // dispatch(
      //   successAlert(` ${result.statusText} College Deleted`, result.status)
      // );
      dispatch(removeLoading());

      dispatch(closeModal()); //Mejorar
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

//Settings
export const setCollegeToUpdating = (college) => {
  return (dispatch) => {
    dispatch({ type: types.setCollegeToUpdate, payload: college });
  };
};

export const removeCollegefromUpdating = () => {
  return (dispatch) => {
    dispatch({ type: types.removeCollegeFromUpdate });
  };
};

export const setCollegeToDeleting = (collegeId) => {
  return (dispatch) => {
    dispatch({ type: types.setCollegeToDelete, payload: collegeId });
  };
};

export const removeCollegefromDeleting = () => {
  return (dispatch) => {
    dispatch({ type: types.removeCollegeFromDelete });
  };
};

export const setCollegeInformation = (college) => {
  return (dispatch) => {
    dispatch({ type: types.setCollegeInformation, payload: college });
  };
};
export const removeCollegeInformation = () => {
  return (dispatch) => {
    dispatch({ type: types.removeCollegeInformation });
  };
};
